<template>
  <span>
    <date-display v-if="from" :date="from"/>
    <template v-if="from && till">
      -
    </template>
    <date-display v-if="till" :date="till"/>
  </span>
</template>

<script>
import DateDisplay from '@/components/base/DateDisplay'
export default {
  name: 'date-range-display',
  components: { DateDisplay },
  props: {
    from: String,
    till: String,
  },

}
</script>

<style lang="scss">
  .date-display {

  }
</style>
